import React from 'react';
import css from './icon.module.css'
import { AiOutlineWhatsApp } from 'react-icons/ai';

export const whatsappIcon = ({ ariaLabel = 'Whatsapp' }) => {
  return (
    <AiOutlineWhatsApp className={css.icon}/>
  );
};